export { default as PickingBatchList } from './PickingBatchList';
export { default as PickingBatchListDetail } from './PickingBatchListDetail';



// WEBPACK FOOTER //
// ./src/modules/picking-batch/pages/index.js